// TODO: DELETE THIS FILE WHEN ALL METHODS HAVE BEEN CONVERTED

import { OrganizationManager } from '@entities';

import { organizationManagerRepo, userRepo } from '@repositories';
import { HyperBackendMethod } from '@shared/backend/hyper-backend-method';
import { BaseRoles, Roles } from '@shared/Roles';
import type { EntityFilter } from 'remult';
import { Controller, remult } from 'remult';
import type { SessionContext } from 'server/src/context/context.type';
import { BackendOnly } from '../backend/backend-only.decorator';
import { type Block } from '../config';

export type Fail = {
    BLOCKED: {
        timeRemaining: number;
        blockType: Block;
    };
    FORBIDDEN: {};
    GUEST_NOT_VALIDATED: {};
    WAIT_BEFORE_ANOTHER_CODE: {
        timeRemaining: number;
    };
    CODE_EXPIRED: {};
    ERROR_SENDING_SMS: {
        error: any;
    };
    USER_DID_NOT_REQUEST_CODE: {};
    CODE_INCORRECT: {};
    NOT_A_GUEST: {};
};

export type HelperResponse<
    T extends keyof Fail = keyof Fail,
    ADD extends Record<string, any> | never = never,
> = T extends any
    ?
          | ({
                success: true;
            } & ([ADD] extends [never] ? {} : ADD))
          | (Fail[T] & {
                success: false;
                reason: T;
            })
    : never;

@Controller('auth')
export class AuthController {
    @BackendOnly()
    static async createSessionForUser(params: {
        id: string;
        role: 'user' | 'manager';
    }) {
        const { role, id } = params;
        const req = remult.context.request;
        if (!req) throw new Error('Request does not exist in remult context');
        req.session ??= {};

        let session: SessionContext;

        if (role === 'manager') {
            const manager = await organizationManagerRepo.findId(id, {
                include: {
                    teams: true,
                    organization: true,
                },
            });
            if (!manager) throw new Error('Not found');
            session = {
                id,
                roles: manager.roles,
                phoneNumber: manager.phoneNumber,
                tableSource: 'organization-manager',
                memberId: '',
            };
        } else {
            const user = await userRepo.findId(id, {
                include: {
                    associations: true,
                },
            });
            if (!user) throw new Error('Not found');
            session = {
                id,
                roles: user.roles as BaseRoles[],
                tableSource: 'user',
                phoneNumber: user.phoneNumber,
                memberId: '',
            };
        }

        req.session!.user = session;

        return session;
    }

    @HyperBackendMethod({ allowed: Roles.SuperAdmin, overrideSecurity: true })
    static async AdminRolesChange(
        isAdmin: boolean,
        whereToUpdate: EntityFilter<OrganizationManager>,
    ) {
        await organizationManagerRepo.updateMany({
            where: whereToUpdate,
            set: {
                roles: isAdmin ? [Roles.Admin] : [Roles.Manager],
            },
        });
        return {
            success: true,
        };
    }
}
